/**
 * Serialisiert ein JSON-LD-Objekt für die Einbettung in ein
 * `<script type="application/ld+json">`-Tag.
 *
 * Der Inhalt eines ld+json-Blocks wird vom Browser als JSON geparst (nicht als
 * JS ausgeführt). Kritisch ist daher nur, dass der String nicht aus dem
 * Script-Tag ausbrechen kann: `<`, `>` und `&` werden als `\uXXXX` maskiert
 * (insb. gegen `</script>`). Das ist die übliche Absicherung für inline-JSON-LD.
 */
export function serializeJsonLd(data: unknown): string {
	return JSON.stringify(data)
		.replace(/</g, '\\u003c')
		.replace(/>/g, '\\u003e')
		.replace(/&/g, '\\u0026');
}
